import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const CorrectThickIcon = (props: SvgProps) => (
    <Svg width={12} height={12} viewBox="0 0 12 12" fill="none" {...props}>
        <Path
            d="M2.38281 5.75631L4.64477 8.01826C4.84003 8.21352 5.1566 8.21352 5.35186 8.01827L9.62035 3.75"
            stroke={props.color || ds.colorValue.icon.primary}
            strokeWidth={1.5}
        />
    </Svg>
);
